import { BaseModel } from '../../_base/crud';

export class Reason extends BaseModel {
  id: number;
  reason: string;
}
